import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { FooterSettings } from '../models/footer-settings';
import { ReduxDispatch } from '../../../../store/use-thunk-dispatch';

export const REQUEST_FOOTER_SETTINGS = 'REQUEST_FOOTER_SETTINGS';
export const RECEIVE_FOOTER_SETTINGS = 'RECEIVE_FOOTER_SETTINGS';
export const FOOTER_SETTINGS_ERROR = 'FOOTER_SETTINGS_ERROR';
export const UPDATE_FOOTER_LINKS = 'UPDATE_FOOTER_LINKS';

const receiveFooterSettings = (links: FooterSettings) => {
    return {
        type: RECEIVE_FOOTER_SETTINGS,
        links,
    };
};

const updateLinks = (links: FooterSettings) => {
    return {
        type: UPDATE_FOOTER_LINKS,
        links,
    };
};

export const fetchFooterSettings = () => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: REQUEST_FOOTER_SETTINGS });

        const response = await api.contentManagement.FooterSetting.getFooterSettings();

        if (response.success) {
            dispatch(receiveFooterSettings(response.result));
        } else {
            dispatch({ type: FOOTER_SETTINGS_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateFooterLinks = (links: FooterSettings) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.contentManagement.FooterSetting.updateFooterLinks(links);

        if (response.success) {
            dispatch(updateLinks(links));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.contentManagement.footer.saved')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
